import(/* webpackMode: "eager" */ "/home/hpbs/frontend/app/[locale]/error.tsx");
